
import { Box } from '@mui/system';
import {RichTextInput} from 'ra-input-rich-text';
import * as React from 'react';
import {
  Edit,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  ImageInput,
  BooleanInput,
  NumberInput,
  DateInput,
  DateTimeInput,
  ImageField,
} from 'react-admin';

export default function ResourceEdit(props:any) {
  return (
    <Box style={styles.boxStyle}>
      <Edit sx={styles.editStyle} {...props}>
        <SimpleForm>
        <TextInput source="name"  sx={styles.inputStyle} /><TextInput multiline source="description"  sx={styles.inputStyle} /><TextInput source="code"  sx={styles.inputStyle} /><NumberInput source="discount"  sx={styles.inputStyle} /><BooleanInput source="isPercentage"  sx={styles.inputStyle} /><DateTimeInput source="startDate"  sx={styles.inputStyle} /><DateTimeInput source="endDate"  sx={styles.inputStyle} /><TextInput source="minShop"   sx={styles.inputStyle}/><TextInput source="maxShop"   sx={styles.inputStyle}/><TextInput source="participationsLimit"   sx={styles.inputStyle}/><BooleanInput source="isActive"  sx={styles.inputStyle} />
        </SimpleForm>
      </Edit>
    </Box>
  );
}

const styles = {
  boxStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  editStyle: {
    width: '50%',
    minWidth:200
  },
  inputStyle: {
    width: '100%',
  },
};

    